import { render, staticRenderFns } from "./DedicationNewSaleDialog.vue?vue&type=template&id=1904adf1&scoped=true&"
import script from "./DedicationNewSaleDialog.vue?vue&type=script&lang=js&"
export * from "./DedicationNewSaleDialog.vue?vue&type=script&lang=js&"
import style0 from "./DedicationNewSaleDialog.vue?vue&type=style&index=0&id=1904adf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1904adf1",
  null
  
)

export default component.exports